(function () {
  'use strict';

  var shellSelector = '[data-collection-description-shell]';
  var mobileQuery = window.matchMedia('(max-width: 719px)');
  var resizeFrame = 0;

  function setExpanded(shell, expanded) {
    var button = shell.querySelector('[data-collection-description-toggle]');
    var more = shell.querySelector('[data-collection-description-more]');
    var less = shell.querySelector('[data-collection-description-less]');

    shell.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    more.hidden = expanded;
    less.hidden = !expanded;
  }

  function updateShell(shell) {
    var description = shell.querySelector('[data-collection-description]');
    var button = shell.querySelector('[data-collection-description-toggle]');
    if (!description || !button) return;

    if (!mobileQuery.matches) {
      shell.classList.remove('is-collapsible', 'is-expanded');
      button.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      return;
    }

    shell.classList.add('is-collapsible');
    shell.classList.remove('is-expanded');
    button.hidden = false;

    var isOverflowing = description.scrollHeight > description.clientHeight + 1;
    shell.classList.toggle('is-collapsible', isOverflowing);
    button.hidden = !isOverflowing;
    setExpanded(shell, false);
  }

  function initialize(root) {
    var shells = [];
    if (root.matches && root.matches(shellSelector)) shells.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll(shellSelector).forEach(function (shell) {
        shells.push(shell);
      });
    }

    shells.forEach(function (shell) {
      if (shell.dataset.collectionDescriptionReady === 'true') {
        updateShell(shell);
        return;
      }

      shell.dataset.collectionDescriptionReady = 'true';
      var button = shell.querySelector('[data-collection-description-toggle]');
      if (!button) return;

      button.addEventListener('click', function () {
        setExpanded(shell, !shell.classList.contains('is-expanded'));
      });

      updateShell(shell);
    });
  }

  function updateAll() {
    document.querySelectorAll(shellSelector).forEach(updateShell);
  }

  function scheduleUpdate() {
    if (resizeFrame) return;
    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = 0;
      updateAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    }, { once: true });
  } else {
    initialize(document);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      window.requestAnimationFrame(function () {
        document.querySelectorAll(shellSelector).forEach(function (shell) {
          if (!shell.classList.contains('is-expanded')) {
            updateShell(shell);
          }
        });
      });
    });
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', updateAll);
  } else {
    mobileQuery.addListener(updateAll);
  }
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
